import { useState } from 'react';
import { useAppConfig } from '../../context/AppConfigContext';
import styles from './GameStatsTabs.module.css';

const GameStatsTabs = ({ stats }) => {
  const [tab, setTab] = useState('day');
  const { t } = useAppConfig();

  const data = stats[tab];
  const bestGame = data?.bestUserGame;
  const lastGame = data?.lastUserGame;

  const renderUserStats = () => {
    if (!bestGame && !lastGame) return <p>{t.game.no_data}</p>;

    const userGames = [
      bestGame ? { ...bestGame, label: t.game.bestGame } : null,
      lastGame && lastGame.id !== bestGame?.id ? { ...lastGame, label: t.game.currentGame } : null,
    ].filter(Boolean);

    return (
      <div className={styles.leaderboard}>
        <h4>{t.game.your_results}</h4>
        <table>
          <thead>
            <tr>
              <th>{t.game.type}</th>
              <th>#</th>
              <th>{t.game.rounds}</th>
              <th>{t.game.errors}</th>
              <th>{t.game.date}</th>
            </tr>
          </thead>
          <tbody>
            {userGames.map((game, idx) => (
              <tr key={idx} className={styles.userRow}>
                <td>{game.label}</td>
                <td>{game.rank ?? '-'}</td>
                <td>{game.round}</td>
                <td>{game.errors >= 0 ? game.errors : '-'}</td>
                <td>{new Date(game.played_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {tab === 'day' && lastGame && (
          <div className={styles.extraStats}>
            <p>{t.game.gameDuration}: {lastGame.game_duration} {t.game.sec}</p>
            <p>{t.game.averagePhraseTime}: {(lastGame.average_phrase_time / 10).toFixed(1)} {t.game.sec}</p>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className={styles.statsContainer}>
      <div className={styles.tabs}>
        {['day', 'week', 'month'].map((period) => (
          <button
            key={period}
            onClick={() => setTab(period)}
            className={tab === period ? styles.active : ''}
          >
            {period === 'day' ? t.game.today : period === 'week' ? t.game.week : t.game.month}
          </button>
        ))}
      </div>

      {data?.top5?.length > 0 ? (
        <div className={styles.leaderboard}>
          <h4>{t.game.top5}</h4>
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>{t.game.rounds}</th>
                <th>{t.game.errors}</th>
                <th>{t.game.date}</th>
              </tr>
            </thead>
            <tbody>
              {data.top5.map((item) => (
                <tr key={item.id}>
                  <td>{item.rank}</td>
                  <td>{item.round}</td>
                  <td>{item.errors >= 0 ? item.errors : '-'}</td>
                  <td>{new Date(item.played_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>{t.game.no_leaderboard}</p>
      )}

      {renderUserStats()}
    </div>
  );
};

export default GameStatsTabs;
